<template>
    <div class="coverWrapper">
        <div class="blurredCover">
            <div class="blurredCoverImage loadEffect"></div>
        </div>
        <div class="cover">
            <div class="coverImage loadEffect"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CoverSkeleton',
    }
</script>

<style scoped lang="scss">
    .coverWrapper {
        display: flex;
        justify-content: center;
        padding: 2rem 1rem 1rem 1rem;
        width: 100%;
    }
    
    .cover {
        position: relative;
        height: 28rem;
        max-width: 72rem;
        width: 100%;
    }

    .blurredCover {
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        overflow: hidden;

        &::after {
            content: '';
            position: fixed;
            width: 100%;
            height: 90%;
            top: 0;
            left: 0;
            background: var(--gradient-black-1-black-0);
        }
    }

    .blurredCoverImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0.5;
    }

    .coverImage {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        object-fit: cover;
        background: var(--color-grey-200);
        border-radius: 1rem;
    }

    @media all and (max-width: 1024px) {
        .coverWrapper {
            padding: 0;
        }

        .cover {
            height: 24rem;
        }

        .coverImage {
            border-radius: 0 0 1rem 1rem;
        }
    }

    @media all and (max-width: 640px) {
        .cover {
            height: 16rem;
        }
    }
</style>